import { createContext } from 'react';

const CheckboxOrRadioGroupContext = /*#__PURE__*/createContext(null);
var CheckboxOrRadioGroupContext$1 = CheckboxOrRadioGroupContext;

export { CheckboxOrRadioGroupContext$1 as default };
